var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3703 26.3106C20.3703 27.9468 19.0442 29.2736 17.4069 29.2736C15.7704 29.2736 14.4443 27.9468 14.4443 26.3106C14.4443 24.6744 15.7704 23.3477 17.4069 23.3477C19.0442 23.3477 20.3703 24.6744 20.3703 26.3106Z",
    stroke: "#FF6262",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.71774C6.09565 5.69148 11.7524 3.19922 18 3.19922C24.2476 3.19922 29.9051 5.69148 34 9.71774",
    stroke: "#FF6262",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14844 15.0513C9.03018 12.1227 13.0109 10.3105 17.4077 10.3105C21.8045 10.3105 25.7844 12.1227 28.667 15.0513",
    stroke: "#FF6262",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8887 19.7911C12.633 17.9602 15.0424 16.8281 17.7031 16.8281C20.3646 16.8281 22.7739 17.9602 24.5183 19.7911",
    stroke: "#FF6262",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/Offline.bfb7685c3e22154e1b53bab53963452c.svg";
export { ForwardRef as ReactComponent };